




























































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchReasignacionEquipos } from './fetchReasignacionEquipos';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class EditarEditar extends Vue {
  @Prop({ default: false }) coordinadores!: any;
  @Prop({ default: false }) tecnicos!: any;
  @Prop({ default: false }) usuarioActivo!: any;

  @Prop({ default: false }) editedItem!: any;
  //@Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ default: false }) isView!: boolean;
  @Prop({ default: false }) esDetalles!: boolean;
  @Prop({
    default: () => ({ id: 0, nombre: '', estado: EstadoEntidad.Activo }),
  })
  getNameModal() {
    if (this.isEdit) {
      return 'Editar Reasignación';
    }
    if (this.isView) {
      return 'Informar Reasignación';
    }
    return 'Ver Detalle Reasignación';
  }
  datoEditado: any = {};
  sim: any = [];
  tipoeq: any = [];
  serieNum: any = [];
  tecnicoList: any = [];

  accion!: any;
  ordesList2: any;
  data: any = {};
  btnBloquearGuardado: boolean = false;

  anulado: boolean = false;
  existereceptor: boolean = false;
  existeFechaR: boolean = false;
  async getDespacho() {
    this.ordesList2 = (await this.loadEditData()) || [];
    this.data = this.ordesList2[0];
    this.formFields.coordinador.value = this.data.coorid;
    this.formFields.tecnico.value = this.data.tecnicoid;
    this.formFields.NDV.value = this.data.ndvnumero_destino;
    this.loadnumeroSerie();
    this.formFields.serie.value = this.data.serienumero;
    this.loadDatos();
    this.formFields.EPC.value = this.data.ndvepc_destino;
    this.formFields.fundamento.value = this.data.reasigobserva;
    this.formFields.tEquipo.value = this.data.tipoeqid;
    this.formFields.sim.value = this.data.simserienumero;
  }

  mounted() {
    this.getDespacho();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  formFields: FormFieldDefMap = {
    tecnico: {
      label: 'Técnico',
      id: 'tecnicoid',
      value: '',
    },
    coordinador: {
      label: 'Coordinador',
      id: 'coorid',
      value: '',
    },
    NDV: {
      label: 'Nota de Venta',
      id: '',
      value: '',
    },
    EPC: {
      label: 'EPC',
      id: '',
      value: '',
    },
    fundamento: {
      label: 'Motivo',
      id: '',
      value: '',
    },
    tEquipo: {
      label: 'Tipo de Equipo',
      id: 'tequipoid',
      value: '',
    },
    serie: {
      label: 'Serie',
      id: '',
      value: '',
    },
    sim: {
      label: 'SIM',
      id: '',
      value: '',
    },
  };
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Despacho;

  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  mensajeConfirmacion: TranslateResult = '';

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  datosEditados: any = {};

  grabarEdicion() {
    this.datosEditados = {
      usuario: this.usuarioActivo[0].id,
      rut: this.usuarioActivo[0].rut,
      coordinador: this.formFields.coordinador.value,
      notaventa: this.formFields.NDV.value,
      epc: this.formFields.EPC.value,
      motivo: this.formFields.fundamento.value,
      tecnico: this.formFields.tecnico.value,
      serie: this.formFields.serie.value,
      tipoEquipo: this.formFields.tEquipo.value,
      sim: this.formFields.sim.value ? this.formFields.sim.value : null,
      reasignumero: this.editedItem,
    };
    if (
      this.datosEditados.coordinador == '' ||
      this.datosEditados.tecnico == '' ||
      this.datosEditados.motivo == '' ||
      this.datosEditados.serie == '' ||
      this.datosEditados.tipoeq == '' ||
      this.datosEditados.notaventa == ''
    ) {
      this.$snotify.error('Por favor ingrese todos los campos obligatorios', {
        timeout: 3000,
      });
      return;
    }
    this.editar();
  }
  async editar() {
    let self = this;
    return fetchReasignacionEquipos(
      {
        reasignumero: this.datosEditados.reasignumero,
        usuario: this.datosEditados.usuario,
        rut: this.datosEditados.rut,
        coordinador: this.datosEditados.coordinador,
        notaventa: this.datosEditados.notaventa,
        epc: this.datosEditados.epc,
        motivo: this.datosEditados.motivo,
        tecnico: this.datosEditados.tecnico,
        tipoequipo: this.datosEditados.tipoEquipo,
        serienumero: this.datosEditados.serie,
        simserienumero: this.datosEditados.sim,
      },
      'conectaReasignacion/editar'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualización Exitosa', { timeout: 3000 });
          this.closeModal(false);
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        return null;
      });
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    /* if (this.esEdicion) {
          accion = 'Ver Detalle';
        } else if(!this.esInformar){
    
        } */
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.$emit('datoEditado', true);
    this.dialog = false;
    this.btnBloquear = false;
  }

  confirmCallback(val: any) {}

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  loadDatos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReasignacionEquipos(
      {
        serienumero: this.formFields.serie.value,
      },
      'conectaReasignacion/loadDatosReasignacion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.tipoeq = data.data.TIPOEQ;
          this.sim = data.data.SIM;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  loadnumeroSerie() {
    this.formFields.serie.value = '';
    this.formFields.sim.value = '';
    this.formFields.tEquipo.value = '';
    this.tipoeq = [];
    let self = this;
    this.loadingService.showLoading();
    return fetchReasignacionEquipos(
      {
        tecnico: this.formFields.tecnico.value,
      },
      'conectaReasignacion/loadNumeroSerie'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.serieNum = data.data.SERIE;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  loadEditData() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReasignacionEquipos(
      {
        reasignumero: this.editedItem,
      },
      'conectaReasignacion/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
}
